import type { MenuState } from "@fluentui/react-components";
import {
  useMenu_unstable,
  toMountNodeProps,
  mergeClasses,
} from "@fluentui/react-components";
import { useMenuStyles } from "./useAppMenuStyles";
import type { AppMenuProps } from "./AppContextualMenu.types";

export const useAppMenu = (props: AppMenuProps): MenuState => {
  const styles = useMenuStyles();
  const mountNodeProps = toMountNodeProps(props.mountNode);
  mountNodeProps.className = mergeClasses(
    props.position === "above" ? styles.portalAbove : styles.portalBelow,
    mountNodeProps.className
  );

  const state = useMenu_unstable({ ...props, mountNode: mountNodeProps });

  return state;
};
